import React from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';

const MainWrapper = styled.main`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.colors.background};
`;
interface Props {
  children: React.ReactNode;
  loggedIn: boolean;
}

const Layout: React.FC<Props> = ({children}) => (
  <>
    <MainWrapper>{children}</MainWrapper>
  </>
);

// @ts-ignore
const mapStateToProps = ({firebase}) => ({
  loggedIn: firebase.auth,
});

export default connect(mapStateToProps)(Layout);
